<template>
    <v-form ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.summary')}}</div>
            <div class="subheading">{{__('labels.summary_subtitle')}}
            </div>
            <v-layout row wrap>
                <v-dialog
                        v-model="previewDialog"
                        max-width="500"
                        fullscreen hide-overlay transition="dialog-bottom-transition"
                >
                    <v-card height="100%">
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click="previewDialog = false; previewUrl=null;">
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>{{__('labels.preview')}}</v-toolbar-title>
                        </v-toolbar>
                        <iframe :src="previewUrl"></iframe>
                    </v-card>
                </v-dialog>
                <summary-table :items="addressTableItems" :title="__('labels.address')" :step="1"
                               :disabled="disabled"></summary-table>
                <summary-table :items="eventTableItems" :title="__('labels.event')" :step="2"
                               :disabled="disabled"></summary-table>
                <summary-table :items="invoiceTableItems" :title="__('labels.invoice')" :step="3"
                               :disabled="disabled"></summary-table>
                <summary-table :items="bankAccountTableItems" :title="__('labels.bank_account')" :step="4"
                               :disabled="disabled"></summary-table>
                <summary-table :items="taxesTableItems" :title="__('labels.taxes')" :step="5"
                               :disabled="disabled"></summary-table>
                <summary-table :items="royaltiesTableItems" :title="__('labels.royalty')" :step="6"
                               :disabled="disabled"></summary-table>
                <summary-table :items="travelingExpensesTableItems" :title="__('labels.traveling_expense')" :step="7"
                               :disabled="disabled"></summary-table>
                <summary-table :items="sumTableItems" :title="__('labels.sum')"></summary-table>
                <v-flex xs12>
                    <v-checkbox v-model="privacyPolicy" :rules="rules.privacyPolicy">
                        <span slot="label">{{__('labels.privacy_text_part1')}}<a
                                @click.prevent.stop="$store.commit('setPrivacyPolicy', true)">{{__('labels.privacy_text_link')}}</a>{{__('labels.privacy_text_part2')}}</span>
                    </v-checkbox>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous :disabled="disabled"></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <v-btn @click="previewButtonClick()" :disabled="disabled" :loading="previewLoading">{{__('labels.preview')}}</v-btn>
                    <button-next @click="nextButtonClick()" :disabled="disabled" :loading="submitLoading">{{__('general.send')}}
                    </button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    const objectToFormData = require('object-to-formdata/index');
    import {mapState} from 'vuex'
    import {mapActions} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapGetters} from 'vuex'

    export default {
        name: "SummaryStep",
        data() {
            return {
                previewUrl: null,
                previewDialog: false,
                privacyPolicy: false,
                rules: this.$validation.create({
                        privacyPolicy: ['required'],
                    }
                )
            }
        },
        computed: {
            ...mapState('form', [
                "address",
                'event',
                'events',
                "performanceDates",
                "invoice",
                "bankAccount",
                "taxes",
                "royalties",
                "travelingExpenses",
                "miscTravelingExpenses",
                "receipts",
                "expensesSum",
                "countries",
            ]),
            ...mapGetters('stepper', [
                'disabled',
            ]),
            ...mapState('stepper', [
                'submitLoading',
                'previewLoading',
            ]),
            addressTableItems() {
                return [
                    {name: this.__('labels.address_email'), value: this.address.email},
                    {name: this.__('labels.address_company'), value: this.address.company},
                    {name: this.__('labels.address_salutation'), value: this.address.salutation},
                    {name: this.__('labels.address_title'), value: this.address.title},
                    {name: this.__('labels.address_first_name'), value: this.address.first_name},
                    {name: this.__('labels.address_last_name'), value: this.address.last_name},
                    {name: this.__('labels.address_street'), value: this.address.street},
                    {name: this.__('labels.address_street_suffix'), value: this.address.street_suffix},
                    {name: this.__('labels.address_zip'), value: this.address.zip},
                    {name: this.__('labels.address_city'), value: this.address.city},
                    {name: this.__('labels.address_country'), value: _.find(this.countries, {value: this.address.country_code}).text},
                    {name: this.__('labels.address_phone'), value: this.address.phone},
                ];
            },
            eventTableItems() {
                let event = _.find(this.events, {id: this.event});
                let name = null;
                let dates = [];
                if (event) {
                    name = event.name;
                }
                _.each(this.performanceDates, (performanceDate) => {
                    dates.push(this.renderDates(performanceDate.dates));
                });
                return [
                    {name: this.__('labels.event_event'), value: name},
                    {name: this.__('labels.event_performance_dates'), value: dates, type: 'list'},
                ];
            },
            invoiceTableItems() {
                return [
                    {name: this.__('labels.invoice_invoice_number'), value: this.invoice.invoice_number},
                    {name: this.__('labels.invoice_invoice_date'), value: this.renderDate(this.invoice.date)},
                    {name: this.__('labels.invoice_tax_id'), value: this.invoice.tax_id},
                ];
            },
            bankAccountTableItems() {
                return [
                    {name: this.__('labels.bank_account_iban'), value: this.bankAccount.iban},
                    {name: this.__('labels.bank_account_swift'), value: this.bankAccount.swift},
                    {name: this.__('labels.bank_account_owner'), value: this.bankAccount.owner},
                ];
            },
            taxesTableItems() {
                let text = '';
                switch (this.taxes) {
                    case '19':
                        text = this.__('labels.taxes_19');
                        break;
                    case 'reverse':
                        text = this.__('labels.taxes_reverse');
                        break;
                    case '0':
                        text = this.__('labels.taxes_0');
                        break;
                    default:
                        break;
                }
                return [
                    {name: this.__('labels.taxes'), value: text},
                ];
            },
            royaltiesTableItems() {
                if (this.royalties) {
                    return [
                        {name: this.__('labels.royalty_royalty'), value: this.renderPrice(this.royalties)},
                    ];
                } else {
                    return [];
                }
            },
            travelingExpensesTableItems() {
                let items = [];
                if (this.expensesSum && this.expensesSum !== 0) {
                    _.each(this.travelingExpenses, (expense) => {
                        if (expense.brutto) {
                            if (this.taxes === '19') {
                                items.push({
                                    name: this.__('invoices.netto_sum') + ' ' + expense.name,
                                    value: this.renderPrice(expense.netto)
                                });
                            } else {
                                items.push({name: expense.name, value: this.renderPrice(expense.brutto)});
                            }
                        }
                    });
                    _.each(this.miscTravelingExpenses, (expense) => {
                        if (expense.brutto) {
                            if (this.taxes === '19') {
                                items.push({name: expense.description, value: this.renderPrice(expense.netto)});
                            } else {
                                items.push({name: expense.description, value: this.renderPrice(expense.brutto)});
                            }
                        }
                    });
                    items.push({
                        name: this.__('invoices.travel_sum') + (this.taxes === '19' ? ' ' + this.__('invoices.netto') : ''),
                        value: this.renderPrice(this.expensesSum)
                    });
                }
                return items;
            },
            sumTableItems() {
                if (this.sumNetto) {
                    if (this.taxes === '19') {
                        return [
                            {name: this.__('invoices.total_sum') + ' ' + this.__('invoices.netto'), value: this.renderPrice(this.sumNetto)},
                            {name: this.__('invoices.taxes') + ' '+this.taxesText+'%', value: this.renderPrice(this.sumTaxes)},
                            {name: this.__('invoices.total_sum') + ' ' + this.__('invoices.brutto'), value: this.renderPrice(this.sumBrutto)},
                        ];
                    } else {
                        return [
                            {name: this.__('invoices.total_sum'), value: this.renderPrice(this.sumNetto)},
                        ];
                    }
                }
                return [];
            },
            sumNetto: {
                get() {
                    return this.royalties + this.expensesSum;
                },
            },
            sumTaxes: {
                get() {
                    let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                    let firstDate = flattenedDates[0]
                    if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))) {
                        return Math.round(this.sumNetto * 0.16);
                    }
                    return Math.round(this.sumNetto * 0.19);
                },
            },
            sumBrutto: {
                get() {
                    return this.sumNetto + this.sumTaxes;
                },
            },
            taxesText() {
                let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                let firstDate = flattenedDates[0]
                if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))) {
                    return 16
                }
                return 19
            }
        },
        methods: {
            ...mapActions('form', [
                'setError',
            ]),
            ...mapGetters('stepper', [
              'locale',
            ]),
            ...mapMutations('stepper', [
                'setSubmitLoading',
                'setPreviewLoading'
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.setSubmitLoading(true);
                    let rawFormData =
                        {
                            address: this.address,
                            invoice: this.invoice,
                            event: this.event,
                            bankAccount: this.bankAccount,
                            performanceDates: this.performanceDates,
                            taxes: this.taxes,
                            royalties: this.royalties,
                            travelingExpenses: this.travelingExpenses,
                        };
                    if (!_.isEmpty(this.miscTravelingExpenses)) {
                        rawFormData.miscTravelingExpenses = this.miscTravelingExpenses;
                    }
                    if (!_.isEmpty(this.receipts.receiptsNew)) {
                        rawFormData.receipts = this.receipts.receiptsNew;
                    }
                    const formData = objectToFormData(
                        rawFormData,
                        {indices: true}
                    );
                    axios.post((this.locale()==='en'? '/en':'')+'/store',
                        formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {
                        if (response.data.url) {
                            this.$cookies.remove('step');
                            this.$cookies.remove('cancelled');
                            this.$cookies.set('completed', true);
                            this.$cookies.remove('invoice');
                            this.$cookies.remove('event');
                            this.$cookies.remove('performanceDates');
                            this.$cookies.remove('royalties');
                            this.$cookies.remove('travelingExpenses');
                            this.$cookies.remove('miscTravelingExpenses');
                            window.location.href = (this.locale()==='en'? '/en':'')+response.data.url;
                        } else {
                            this.setSubmitLoading(false);
                            this.setError(this.__('messages.unexpected_error'));
                        }
                    }).catch(() => {
                        this.setSubmitLoading(false);
                        this.setError(this.__('messages.unexpected_error'));
                    });
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
            previewButtonClick() {
                this.setPreviewLoading(true);
                let rawFormData =
                    {
                        address: this.address,
                        invoice: this.invoice,
                        event: this.event,
                        bankAccount: this.bankAccount,
                        performanceDates: this.performanceDates,
                        taxes: this.taxes,
                        royalties: this.royalties,
                        travelingExpenses: this.travelingExpenses,
                    };
                if (!_.isEmpty(this.miscTravelingExpenses)) {
                    rawFormData.miscTravelingExpenses = this.miscTravelingExpenses;
                }
                const formData = objectToFormData(
                    rawFormData,
                    {indices: true}
                );
                axios.post((this.locale()==='en'? '/en':'')+'/preview',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                    let blob = this.b64toBlob(response.data.pdf, 'application/pdf');
                    this.previewUrl = '/pdfjs/web/viewer.php?file=' + encodeURIComponent(URL.createObjectURL(blob));
                    this.previewDialog = true;
                    this.setPreviewLoading(false);
                }).catch(() => {
                    this.setPreviewLoading(false);
                    this.setError(this.__('messages.unexpected_error'));
                });
            },
            renderPrice(price) {
                if (price) {
                    let renderedPrice = (price / 100).toFixed(2).replace('.', ',');
                    var parts = renderedPrice.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    return parts.join("|") + ' €';
                }
                return '';
            },
            renderDates(dates) {
                if (!dates || _.isEmpty(dates)) {
                    return '';
                } else if (dates.length === 1) {
                    return this.$moment(dates[0]).format('DD.MM.YYYY')
                }
                return this.$moment(dates[0]).format('DD.MM.YYYY') + ' - ' + this.$moment(dates[1]).format('DD.MM.YYYY')
            },
            renderDate(date) {
                if (!date) {
                    return '';
                } else {
                    return this.$moment(date).format('DD.MM.YYYY')
                }
            },
            b64toBlob(b64Data, contentType = '', sliceSize = 512) {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
        }
    }
</script>

<style scoped>
    iframe {
        height: calc(100% - 48px);
        border: 0 none;
        width: 100%;
    }

    @media screen and (min-width: 960px) {
        iframe {
            height: calc(100% - 64px);
        }
    }
</style>
